import { funnelUtilsConstants as utilsConstants, translationUtilsConstants } from "@puls/puls-common-constants";
import routesConstants from "./routes";

export default {
    ...utilsConstants,
    SALES_CART_NO_SERVER_PRICES_ROUTES: [
        routesConstants.RE_ADDONS
    ],
    TRANSLATION: translationUtilsConstants

};